import { useCallback } from 'react';
import { useGlobalAppStateStore } from './BaseGlobalAppStateStoreProvider';

export const useGetGlobalAppStateStoreState = () => {
  return {
    getGlobalAppStateStoreState: useGlobalAppStateStore().getState,
  };
};

export const useGetDeviceDetailsInStateStore = () => {
  return useGlobalAppStateStore().hooks.useDeviceDetails();
};

export const useDeviceDetailsGetter = () => {
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const getDeviceDetails = useCallback(
    () => getGlobalAppStateStoreState().deviceDetails,
    [getGlobalAppStateStoreState],
  );
  return { getDeviceDetails };
};

export const useInterfaceApplicationType = () => {
  const applicationType = useGlobalAppStateStore().hooks.record.useApplicationType();
  return applicationType;
};
